import httpApiApplication from 'app/http/httpApiApplication';

import { type FormCellRequest } from '../formCellRequest';

export const baseUrl = '/formcells';

export function updateFormCell(id: string, request: FormCellRequest) {
  return httpApiApplication.put(`${baseUrl}/${id}`, request);
}

export function deleteFormCell(id: string) {
  return httpApiApplication.delete(`${baseUrl}/${id}`);
}

export const createFormCell = (request: FormCellRequest) => {
  return httpApiApplication.post(baseUrl, request);
};
